var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{staticClass:"max-width"},[_c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }